import { useTranslator } from '@bluebeam/react-i18n';
import BreadcrumbsOfAppState from 'components/BreadcrumbsOfAppState';
import LoadingAnimation from 'components/LoadingAnimation';
import NewFolderDropdownButton from 'components/modals/ExportDataModal/NewFolderDropdownButton';
import { getAccountName } from 'constants/integrations';
import StudioFolderList from 'pages/DrawingsPage/StudioTab/StudioFolderList';
import React, { useEffect, useState } from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

const IntegrationsBrowseFilesStep: React.FC<WithAppStoreProps> = (
  props: WithAppStoreProps
) => {
  const { appStore, actions } = props;
  const { studioExportFolder } = appStore.state;
  const [loaded, setLoaded] = useState(false);
  const accountName = getAccountName('studio');
  const { translate } = useTranslator(['requestDownloadModal']);

  useEffect(() => {
    actions.getStudioProjects();
    setLoaded(true);
  }, [studioExportFolder]);

  return (
    <>
      <div className="column px5 pt9 bb-2 pb3">
        <div className="color-black-2 font-size-7 medium">
          {translate('requestDownloadModal:exportModal.browseFilesStep.title')}
        </div>
        <div className="color-black-1 pt2 font-size-5 pb1 light">
          {translate(
            'requestDownloadModal:exportModal.browseFilesStep.content'
          )}
        </div>
      </div>
      <div className="row px5 pt4 justify-between items-center">
        <div className="color-black-2 font-size-5">
          {translate(
            'requestDownloadModal:exportModal.browseFilesStep.selectedFolders',
            {
              folderCount: !studioExportFolder ? '0' : '1',
            }
          )}
        </div>
        <NewFolderDropdownButton into="studio" />
      </div>
      <div className="oh px5 pb8 w100 mt2">
        <BreadcrumbsOfAppState providerType="studio" />
        <div className="mt2" style={{ height: '390px' }}>
          {loaded ? (
            <StudioFolderList />
          ) : (
            <div className="column h100 w100 b-3 bgd-light-grey-2 justify-center items-center">
              <LoadingAnimation
                pageName={translate(
                  'requestDownloadModal:exportModal.browseFilesStep.loading',
                  { accountName }
                )}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withAppStore<WithAppStoreProps>(IntegrationsBrowseFilesStep);
